import React, { useState } from "react";
import { Button, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import DefaultLogo from "../../assets/logo/DefaultLenderLogo.png";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  input: {
    display: "none",
  },
  imagePreview: {
    width: "100%",
    height: "132px",
    borderRadius: theme.spacing(1),
    objectFit: "cover",
    marginRight: theme.spacing(2),
  },
}));

const ImageUpload = ({ onFileChange, defaultImageUrl, onRemove }) => {
  const classes = useStyles();
  const [image, setImage] = useState(defaultImageUrl);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const dataURL = reader.result;
        setImage(dataURL);
        onFileChange(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemove = () => {
    setImage(DefaultLogo);
    onRemove();
  };
  const renderImage = () => {
    if (image) {
      return image;
    } else if (defaultImageUrl) {
      return defaultImageUrl;
    } else {
      return DefaultLogo;
    }
  };

  return (
    <Grid container spacing={2} className={classes.root}>
      <Grid item xs={12}>
        <img
          src={renderImage()}
          alt="Preview"
          className={classes.imagePreview}
        />
        <div style={{ marginTop: "20px" }}></div>
        <input
          accept="image/*"
          className={classes.input}
          id="image-upload-button"
          type="file"
          onChange={handleFileChange}
        />
        <label htmlFor="image-upload-button">
          <Button
            variant="contained"
            color="primary"
            component="span"
            style={{ color: "white", width: "130px" }}
          >
            Upload
          </Button>
        </label>
        {image !== DefaultLogo && (
          <Button
            variant="outlined"
            color="primary"
            onClick={handleRemove}
            style={{ width: "130px", marginLeft: "20px" }}
          >
            Remove
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default ImageUpload;
